import { render, staticRenderFns } from "./Greenfox.vue?vue&type=template&id=036b4beb&scoped=true&"
import script from "./Greenfox.vue?vue&type=script&lang=js&"
export * from "./Greenfox.vue?vue&type=script&lang=js&"
import style0 from "./Greenfox.vue?vue&type=style&index=0&id=036b4beb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b4beb",
  null
  
)

export default component.exports